export const getVariations = (state) => state.variations
export const getVariation = (state) => (id) => { return state.variations.filter((variation) => { return variation.id == id })[0] }
